import { generateCookieType } from '@/utils/cookie/index'

export const CLOCALE = generateCookieType('locale')
export const CCOUNTRY = generateCookieType('country')
export const CDELIVERYNOTIFICATION = generateCookieType('delivery-notification')

export const CHATBOTLOCALE = 'NEXT_LOCALE'
